module.exports = __webpack_public_path__ + "static/1-ea7806ca781a21a2fc8c731f33f7008c.jpg";